import "./css/d6.css";

export default function MenuTemplateModern({ menu, categories }) {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div
      className="modern-wrapper"
      style={{
        backgroundColor: menu.colors?.background || "#f4f4f4",
        color: menu.colors?.text || "#222",
      }}
    >
      {/* HEADER / STICKY NAV */}
      <header className="modern-header">
        <div className="modern-logo">{menu.name}</div>
        <nav className="modern-tabs">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => scrollTo(cat.id)}
              className="modern-tab-btn"
              style={{
                "--accent": menu.colors?.primary || "#2e7d32",
              }}
            >
              {cat.name}
            </button>
          ))}
        </nav>
      </header>

      {/* HERO SECTION */}
      {menu.imageUrl && (
        <div className="modern-hero">
          <img src={menu.imageUrl} alt="" className="modern-hero-img" />
          <div className="modern-hero-overlay"></div>
          <div className="modern-hero-text">
            <h1 style={{color: "white"}}>{menu.name}</h1>
            {menu.tagline && <p style={{color: "white"}}>{menu.tagline}</p>}
          </div>
        </div>
      )}

      {/* CONTENT */}
      <main className="modern-content">
        {categories.map((cat) => (
          <section
            key={cat.id}
            id={cat.id}
            className="modern-section fade-in"
            style={{
              backgroundColor: menu.colors?.card || "#fff",
            }}
          >
            <h2
              className="modern-section-title"
              style={{
                borderLeft: `6px solid ${menu.colors?.primary || "#2e7d32"}`,
              }}
            >
              {cat.name}
            </h2>

            <div className="modern-items">
              {cat.items.map((item) => (
                <div key={item.id} className="modern-item-card">
                  <div className="modern-item-left">
                    <h3>{item.name}</h3>
                    {item.description && (
                      <p className="modern-item-desc">{item.description}</p>
                    )}
                  </div>

                  <div className="modern-item-right">
                    <span
                      className="modern-item-price"
                      style={{ color: menu.colors?.primary || "#2e7d32" }}
                    >
                      ${parseFloat(item.price).toFixed(2)}
                    </span>

                    {item.imageUrl && (
                      <img
                        src={item.imageUrl}
                        alt=""
                        className="modern-item-img"
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
}
